module.exports = __webpack_public_path__ + "img/003_06.c0c1ba1a.jpg";